<template>
  <div class="cyber-login">
    <div class="cyber-login__logo">
      <img src="/resources/logos/BC_LOGO.png" alt="Business Club" />
      <div class="cyber-login__brand">BUSINESS CLUB</div>
    </div>

    <div class="cyber-login__card">
      <div class="cyber-login__card-glow"></div>
      <div class="cyber-login__header">
        <div class="cyber-login__header-line"></div>
        <h3>SIGN IN</h3>
        <p>Access your trading dashboard</p>
      </div>

      <form @submit="onSubmit" class="cyber-login__form">
        <div class="cyber-input-group">
          <div class="cyber-input-icon">
            <i class="ion ion-email"></i>
          </div>
          <input
            type="text"
            class="form-control cyber-input"
            placeholder="Username"
            v-model="model.username"
            autocomplete="username"
          />
          <div class="cyber-input-border"></div>
        </div>

        <div class="cyber-input-group">
          <div class="cyber-input-icon">
            <i class="ion ion-locked"></i>
          </div>
          <input
            type="password"
            class="form-control cyber-input"
            placeholder="Password"
            v-model="model.password"
            autocomplete="current-password"
          />
          <div class="cyber-input-border"></div>
        </div>

        <div class="d-flex justify-content-between align-items-center mb-4">
          <label class="cyber-checkbox">
            <input type="checkbox" />
            <span class="cyber-checkbox__mark"></span>
            Remember Me
          </label>
          <router-link to="/recovery" class="cyber-link-dim">
            Forgot password?
          </router-link>
        </div>

        <button
          v-if="!loading"
          type="submit"
          class="btn btn-success btn-block cyber-btn-glow"
        >
          <span>INITIALIZE SESSION</span>
          <i class="mdi mdi-login-variant ml-2"></i>
        </button>
        <button
          v-else
          type="submit"
          class="btn btn-success btn-block cyber-btn-glow"
          disabled
        >
          <span>CONNECTING</span>
          <i class="fa fa-circle-o-notch fa-spin ml-2"></i>
        </button>
      </form>

      <div class="cyber-login__footer">
        <div class="cyber-login__divider">
          <span>NEW HERE?</span>
        </div>
        <p>
          <router-link to="/register" class="cyber-link-gold">
            Create Account <i class="mdi mdi-arrow-right"></i>
          </router-link>
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.cyber-login {
  padding: 20px 0;
}

.cyber-login__logo {
  text-align: center;
  margin-bottom: 30px;
}

.cyber-login__logo img {
  width: 100px;
  filter: drop-shadow(0 0 20px rgba(176, 154, 78, 0.4));
  animation: logoPulse 3s ease-in-out infinite;
}

.cyber-login__brand {
  font-family: 'Orbitron', sans-serif;
  font-size: 0.75rem;
  color: rgba(194, 193, 184, 0.6);
  letter-spacing: 0.3em;
  margin-top: 10px;
  text-transform: uppercase;
}

.cyber-login__card {
  position: relative;
  background: rgba(37, 37, 37, 0.85);
  backdrop-filter: blur(30px);
  -webkit-backdrop-filter: blur(30px);
  border: 1px solid rgba(176, 154, 78, 0.12);
  border-radius: 16px;
  padding: 0;
  overflow: hidden;
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.6), 0 0 30px rgba(176, 154, 78, 0.08);
}

.cyber-login__card-glow {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, #B09A4E, #7BBFB5, transparent);
  animation: shimmer 3s ease-in-out infinite;
}

@keyframes shimmer {
  0%, 100% { opacity: 0.6; }
  50% { opacity: 1; }
}

.cyber-login__header {
  padding: 30px 30px 0;
  text-align: center;
}

.cyber-login__header-line {
  width: 30px;
  height: 2px;
  background: #B09A4E;
  margin: 0 auto 15px;
  box-shadow: 0 0 8px rgba(176, 154, 78, 0.5);
}

.cyber-login__header h3 {
  font-family: 'Orbitron', sans-serif !important;
  font-size: 1.1rem !important;
  color: #E0DFD8 !important;
  letter-spacing: 0.15em;
  margin-bottom: 5px;
}

.cyber-login__header p {
  color: rgba(154, 153, 143, 1);
  font-size: 0.85rem;
  margin: 0;
}

.cyber-login__form {
  padding: 25px 30px;
}

/* Custom input group */
.cyber-input-group {
  position: relative;
  margin-bottom: 18px;
}

.cyber-input-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: rgba(176, 154, 78, 0.5);
  z-index: 2;
  font-size: 1rem;
}

.cyber-input {
  padding-left: 42px !important;
  background: rgba(26, 26, 26, 0.7) !important;
  border: 1px solid rgba(61, 61, 55, 0.8) !important;
  color: #E0DFD8 !important;
  border-radius: 10px !important;
  height: 48px !important;
  font-size: 0.9rem !important;
  transition: all 0.3s ease !important;
}

.cyber-input:focus {
  border-color: #B09A4E !important;
  box-shadow: 0 0 0 2px rgba(176, 154, 78, 0.1), 0 0 20px rgba(176, 154, 78, 0.1) !important;
}

.cyber-input:focus + .cyber-input-border {
  opacity: 1;
}

.cyber-input-border {
  position: absolute;
  bottom: 0;
  left: 10%;
  width: 80%;
  height: 1px;
  background: linear-gradient(90deg, transparent, #B09A4E, transparent);
  opacity: 0;
  transition: opacity 0.3s ease;
}

/* Checkbox */
.cyber-checkbox {
  display: flex;
  align-items: center;
  color: rgba(154, 153, 143, 1) !important;
  font-size: 0.8rem !important;
  cursor: pointer;
  text-transform: none !important;
  font-weight: 400 !important;
}

.cyber-checkbox input {
  display: none;
}

.cyber-checkbox__mark {
  width: 16px;
  height: 16px;
  border: 1px solid rgba(61, 61, 55, 1);
  border-radius: 3px;
  margin-right: 8px;
  position: relative;
  transition: all 0.2s ease;
}

.cyber-checkbox input:checked + .cyber-checkbox__mark {
  background: #B09A4E;
  border-color: #B09A4E;
}

.cyber-checkbox input:checked + .cyber-checkbox__mark::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 5px;
  width: 4px;
  height: 8px;
  border: solid #1a1a1a;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

/* Links */
.cyber-link-dim {
  color: rgba(154, 153, 143, 1) !important;
  font-size: 0.8rem !important;
  text-transform: none !important;
}

.cyber-link-dim:hover {
  color: #B09A4E !important;
}

.cyber-link-gold {
  color: #B09A4E !important;
  font-family: 'Orbitron', sans-serif !important;
  font-size: 0.8rem !important;
  letter-spacing: 0.05em;
}

/* CTA button */
.cyber-btn-glow {
  height: 48px !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem !important;
  letter-spacing: 0.12em;
}

/* Footer */
.cyber-login__footer {
  padding: 0 30px 25px;
  text-align: center;
}

.cyber-login__divider {
  position: relative;
  text-align: center;
  margin-bottom: 15px;
}

.cyber-login__divider::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 1px;
  background: rgba(61, 61, 55, 0.5);
}

.cyber-login__divider span {
  position: relative;
  background: rgba(37, 37, 37, 0.85);
  padding: 0 15px;
  font-family: 'Orbitron', sans-serif;
  font-size: 0.6rem;
  color: rgba(154, 153, 143, 0.6);
  letter-spacing: 0.15em;
}

.cyber-login__footer p {
  margin: 0;
}

@keyframes logoPulse {
  0%, 100% { filter: drop-shadow(0 0 15px rgba(176, 154, 78, 0.3)); }
  50% { filter: drop-shadow(0 0 30px rgba(176, 154, 78, 0.6)); }
}
</style>

<script>
import router from "@/router";

export default {
  name: "login",
  data() {
    return {
      loading: false,
      model: {
        username: "",
        password: ""
      }
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.loading = true;
      this.$http
        .post("/api/v1/client/sessions", this.model)
        .then((response) => {
          this.$store.commit("setCurrentUser", response.data.user);
          this.$store.commit("setAuthToken", response.data.auth_token);
          this.storeLogin(response.data);
          this.loading = false;
        })
        .catch((error) => {
          this.$toasted.show(error.response.data.error, {
            position: "top-right",
            duration: 5000,
            type: "error",
            closeOnSwipe: true
          });
          this.loading = false;
        });
    },
    storeLogin(data) {
      let action;
      let firstPage = "dashboard?auth=true";
      if (data.user.temp_user) firstPage = "plans";
      action = async () => {
        await router.push(firstPage);
      };
      action();
    }
  }
};
</script>
